import { FieldAttributes, useField, useFormikContext } from 'formik';
import React, { useCallback } from 'react';
import { Form } from 'react-bootstrap';

type Props = {
  readonly as?: React.ElementType<any>;
  readonly label: string | React.ReactNode;
  readonly type?: 'checkbox' | 'switch';
  readonly id?: string;
  readonly disabled?: boolean;
  readonly underline?: boolean;
  readonly onChange?: (value: boolean, fieldName: string) => void;
} & FieldAttributes<any>;

const FieldTickBox = ({
  as = 'div',
  name,
  label,
  type = 'checkbox',
  id,
  disabled = false,
  underline = false,
  onChange,
}: Props) => {
  const [{ value }, { touched, error }] = useField<boolean>(name);
  const { setFieldValue, setFieldTouched, submitCount } = useFormikContext<any>();

  const handleChange = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked;
      await setFieldValue(name, checked, true);
      await setFieldTouched(name, true, true);
      if (onChange) onChange(checked, name);
    },
    [name, onChange, setFieldTouched, setFieldValue],
  );

  const handleBlur = useCallback(async () => {
    await setFieldTouched(name, true, true);
  }, [name, setFieldTouched]);

  return (
    <Form.Group as={as} controlId={id ?? `formGroup_${name}`} className="mb-2 field-tickbox">
      <Form.Check
        style={
          underline
            ? {
                display: 'inline-block',
                borderBottom: '1px solid #6c757d',
                paddingBottom: '0.15rem',
              }
            : undefined
        }
        type={type}
        id={id ?? `default-${type}-${name}`}
        name={name}
        label={label}
        checked={Boolean(value)}
        disabled={disabled}
        isInvalid={(touched || submitCount > 0) && !!error}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {(touched || submitCount > 0) && !!error && (
        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
          {error}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default FieldTickBox;
